module.exports = __webpack_public_path__ + "img/03.5054a668.jpg";